import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/videos/home/video-mobile.mp4")